<!--
 * @Author: huangyh
 * @Date: 2021-03-12 17:29:25
 * @LastEditors: huangyh
 * @LastEditTime: 2021-04-01 16:24:25
-->
<template>
  <div class="customControlMain">
    <!-- 单选 -->
    <div v-if="type==1" class="singlePick">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写问题（单选）" style="width: 70%"></Input>
      <div class="options">
        <div class="optionItem" v-for="(item, index) in quesInfo.fvs" :key="index">
          <Icon type="android-radio-button-off" style="margin-right:10px"></Icon>
          <span v-if="item.fvType == 2" style="margin-right:3px">其他</span>
          <Input v-model="item.fvValue" :disabled="item.fvType == 2" placeholder style="width: 100px;margin:5px 0;"></Input>
          <Icon type="trash-a delIconStyle" @click.native="quesInfo.fvs.splice(index,1)"></Icon>
        </div>
      </div>
      <div class="addBtn">
        <Button type="primary" size="small" @click="quesInfo.fvs.push({fvValue:'',fvType:1})">添加非正式选项</Button>
        <Button type="primary" size="small" :disabled="quesInfo.fvs.filter(i=> i.fvType==2).length > 0" @click="quesInfo.fvs.push({fvValue:'',fvType:2})">添加其他项</Button>
      </div>
    </div>
    <!-- 多选 -->
    <div v-if="type==2" class="singlePick">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写问题（多选）" style="width: 70%"></Input>
      <div class="options">
        <div class="optionItem" v-for="(item, index) in quesInfo.fvs" :key="index">
          <Icon type="android-checkbox-outline-blank" style="margin-right:10px"></Icon>
          <span v-if="item.fvType == 2" style="margin-right:3px">其他</span>
          <Input v-model="item.fvValue" :disabled="item.fvType == 2" placeholder style="width: 100px;margin:5px 0;"></Input>
          <Icon type="trash-a delIconStyle" @click.native="quesInfo.fvs.splice(index,1)"></Icon>
        </div>
      </div>
      <div class="addBtn">
        <Button type="primary" size="small" @click="quesInfo.fvs.push({fvValue:'',fvType:1})">添加非正式选项</Button>
        <Button type="primary" size="small" :disabled="quesInfo.fvs.filter(i=> i.fvType==2).length > 0" @click="quesInfo.fvs.push({fvValue:'',fvType:2})">添加其他项</Button>
      </div>
    </div>
    <!-- 填空题 -->
    <div v-if="type==3" class="fillBlank">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写问题内容" style="width: 70%"></Input>
      <div class="blank blankSty">
        <div class="blankStyItem">
          <Input v-model="quesInfo.questionValue" type="textarea" class="noBorder" placeholder="请回答" style="width: 100%" disabled></Input>
        </div>
      </div>
    </div>
    <!-- 下拉 -->
    <div v-if="type==4" class="singlePick">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写问题（单选）" style="width: 70%"></Input>
      <div class="options">
        <div class="optionItem" v-for="(item, index) in quesInfo.fvs" :key="index">
          <Icon type="android-arrow-dropdown" style="margin-right:10px"></Icon>
          <Input v-model="item.fvValue" :disabled="item.fvType == 2" placeholder style="width: 100px;margin:5px 0;"></Input>
          <Icon type="trash-a delIconStyle" @click.native="quesInfo.fvs.splice(index,1)"></Icon>
        </div>
      </div>
      <div class="addBtn">
        <Button type="primary" size="small" @click="quesInfo.fvs.push({fvValue:'',fvType:1})">添加非正式选项</Button>
      </div>
    </div>
    <!-- 标题 -->
    <div v-if="type==5" class="singlePick">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写标题" style="width: 70%"></Input>
    </div>
    <!-- 分割线 -->
    <div v-if="type==6" class="divisionBox">
      <div class="division"></div>
    </div>
    <!-- 说明文本 -->
    <div v-if="type==7" class="singlePick">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写说明文本" style="width: 70%"></Input>
    </div>
    <!-- 评分 -->
    <div v-if="type==8" class="singlePick">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写问题" style="width: 70%"></Input>
      <div class="options">
        <div class="optionItem">
          <Rate allow-half show-text disabled></Rate>
        </div>
      </div>
    </div>
    <!-- 横向填空 -->
    <div v-if="type==9" class="fillBlank">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写问题内容" style="width: 70%"></Input>
      <div class="blank blankSty">
        <div class="blankStyItem">
          <Input v-model="quesInfo.content" :rows="8" type="textarea" class="noBorder" placeholder="请回答" style="width: 100%"></Input>
        </div>
        <Icon type="gear-b delIconStyle" @click.native="editInfeedFillBlank"></Icon>
      </div>
    </div>
    <!-- 横向填空编辑框 -->
    <Modal
      v-if="type==9"
      v-model="showInfeedFillBlankModel"
      class-name="allCenter"
      width="50"
      title="横向填空属性"
      @on-ok="saveInfeedFillBlank"
      @on-cancel="closeInfeedFillBlank"
      :closable="false"
      :mask-closable="false"
    >
      <div class="infeedFillBlankDiv">
        <div class="showArea" v-html="infeedFillBlankText"></div>
        <div class="attrArea" ref="fillBlankTableHeight">
          <Table border :columns="infeedFillBlankTableItem" :height="fillBlankTableHeight" :data="infeedFillBlankTableData"></Table>
        </div>
      </div>
    </Modal>
    <!-- 表格 -->
    <div v-if="type==10" class="fillTable">
      <Input v-model="quesInfo.name" class="noBorderByUnline" placeholder="请填写问题内容" style="width: 70%"></Input>
      <div class="tablebox">
        <div class="table">
          <Table border :columns="fillTableColoumns" :data="fillTableData"></Table>
        </div>
        <Icon type="gear-b delIconStyle" @click.native="editTableModel"></Icon>
      </div>
    </div>
    <!-- 表格编辑框 -->
    <Modal v-if="type==10" v-model="showTableModel" class-name="allCenter" width="50" title="表格设置" @on-ok="saveTableModel" @on-cancel="closeTableModel" :closable="false" :mask-closable="false">
      <div class="fillTableDiv">
        <div class="tableB" ref="tableB">
          <Table border :columns="editTableColoumns" :height="tableHeight" :data="editTableData"></Table>
        </div>
        <div class="tableAddB">
          <Button type="primary" size="small" @click="addTableData">添加选项</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { deepCopy } from '@/utils/utils'
export default {
  props: {
    type: {
      default: 1,
      type: Number,
    },
    value: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      quesInfo: {},
      // 横向填空 start
      showInfeedFillBlankModel: false,
      blankType: [
        {
          type: 0,
          label: '不限',
        },
        {
          type: 1,
          label: '数字',
        },
        {
          type: 2,
          label: '字母',
        },
        {
          type: 3,
          label: '汉字',
        },
        {
          type: 4,
          label: 'email',
        },
        {
          type: 5,
          label: '手机号',
        },
      ],
      infeedFillBlankText: '',
      infeedFillBlankTableItem: [
        {
          title: '填空序号',
          type: 'index',
          width: 120,
          align: 'center',
        },
        {
          title: '内容限制',
          key: 'fvType',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Select',
                {
                  props: {
                    value: this.infeedFillBlankTableData[params.index].fvType,
                  },
                  on: {
                    'on-change': (value) => {
                      this.infeedFillBlankTableData[params.index].fvType = value
                    },
                  },
                },
                this.blankType.map((obj) => {
                  return h('Option', {
                    props: { value: obj.type, label: obj.label },
                  })
                })
              ),
            ])
          },
        },
        {
          title: '范围',
          key: 'fvRange',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', '最多填充 '),
              h('InputNumber', {
                props: {
                  value: this.infeedFillBlankTableData[params.index].fvRange,
                  min: 1,
                },
                on: {
                  'on-change': (e) => {
                    params.row.fvRange = e
                    this.infeedFillBlankTableData[params.index] = params.row
                  },
                },
              }),
              h('span', ' 字'),
            ])
          },
        },
        {
          title: '此空必填',
          key: 'isRequired',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Checkbox', {
                props: {
                  value: this.infeedFillBlankTableData[params.index].isRequired,
                  trueValue: 1,
                  falseValue: 0,
                },
                on: {
                  'on-change': (value) => {
                    // eslint-disable-next-line
                    this.infeedFillBlankTableData[
                      params.index
                    ].isRequired = value
                  },
                },
              }),
            ])
          },
        },
      ],
      infeedFillBlankTableData: [],
      fillBlankTableHeight: 0,
      // 横向填空 end
      // 表格 start
      showTableModel: false,
      tableHeight: 0,
      fillTableColoumns: [],
      fillTableData: [{}],
      editTableColoumns: [
        {
          title: '标题',
          key: 'fvName',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Input', {
                props: {
                  value: this.editTableData[params.index].fvName,
                },
                on: {
                  'on-change': (e) => {
                    params.row.fvName = e.target.value
                    this.editTableData[params.index] = params.row
                  },
                },
              }),
            ])
          },
        },
        {
          title: '类型',
          key: 'fvType',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Select',
                {
                  props: {
                    value: this.editTableData[params.index].fvType,
                  },
                  on: {
                    'on-change': (value) => {
                      this.editTableData[params.index].fvType = value
                    },
                  },
                },
                this.blankType.map((obj) => {
                  return h('Option', {
                    props: { value: obj.type, label: obj.label },
                  })
                })
              ),
            ])
          },
        },
        {
          title: '必填',
          key: 'isRequired',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Checkbox', {
                props: {
                  value: this.editTableData[params.index].isRequired,
                  trueValue: 1,
                  falseValue: 0,
                },
                on: {
                  'on-change': (value) => {
                    this.editTableData[params.index].isRequired = value
                  },
                },
              }),
            ])
          },
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'text',
                  },
                  on: {
                    click: () => {
                      this.editTableData.splice(params.index, 1)
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ],
      editTableData: [],
      tableBlankType: [
        {
          type: 1,
          label: '填空',
        },
        {
          type: 2,
          label: '数字',
        },
        {
          type: 3,
          label: '字母',
        },
        {
          type: 4,
          label: '简体中文',
        },
        {
          type: 5,
          label: '电子邮件',
        },
        {
          type: 6,
          label: '手机号码',
        },
        {
          type: 7,
          label: '单选',
        },
      ],
      // 表格 end
    }
  },
  created() {
    this.quesInfo = deepCopy(this.value)
    if (this.quesInfo.type === 9) {
      if (this.quesInfo.fvs.length === 0) {
        let count = 0
        this.infeedFillBlankText = this.quesInfo.content.replace(
          /_+/gi,
          (match) => {
            this.quesInfo.fvs.push({
              fvName: '',
              fvType: 0,
              fvRange: 1,
              isRequired: 0,
              orderNum: count++,
            })
            return '<span class="blackBg">' + match + '</span>'
          }
        )
      }
    }
    if (this.quesInfo.type === 10) {
      if (this.quesInfo.fvs.length > 0) {
        let count = 0
        for (let item of this.quesInfo.fvs) {
          this.fillTableColoumns.push({
            title: item.fvName,
            key: 'col' + count++,
            align: 'center',
            fvType: item.fvType,
            orderNum: item.orderNum,
            isRequired: item.isRequired,
          })
        }
      } else {
        this.fillTableColoumns.push(
          {
            title: '联系人',
            key: 'col1',
            align: 'center',
            fvType: 0,
            orderNum: 1,
            isRequired: 0,
          },
          {
            title: '手机号',
            key: 'col2',
            align: 'center',
            fvType: 5,
            orderNum: 1,
            isRequired: 0,
          },
          {
            title: '性别',
            key: 'col3',
            align: 'center',
            fvType: 0,
            orderNum: 1,
            isRequired: 0,
          }
        )
        for (let item of this.fillTableColoumns) {
          this.quesInfo.fvs.push({
            fvName: item.title,
            fvType: item.fvType,
            isRequired: item.isRequired,
            orderNum: item.orderNum,
          })
        }
      }
    }
  },
  watch: {
    quesInfo: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
    },
  },
  methods: {
    // 编辑横向填空
    editInfeedFillBlank() {
      this.infeedFillBlankTableData.length = 0
      let count = 0
      this.infeedFillBlankText = this.quesInfo.content.replace(
        /_+/gi,
        (match) => {
          let fvsObj = {}
          if (this.quesInfo.fvs[count] !== undefined) {
            fvsObj = this.quesInfo.fvs[count]
          }
          let tempObj = Object.assign(
            {
              fvName: '',
              fvType: 0,
              fvRange: 1,
              isRequired: 0,
              orderNum: count++,
            },
            fvsObj
          )
          this.infeedFillBlankTableData.push(tempObj)
          return '<span class="blackBg">' + match + '</span>'
        }
      )
      this.infeedFillBlankText = this.infeedFillBlankText.replace(
        /(\r\n|\n|\r)/gm,
        '</br>'
      )
      this.showInfeedFillBlankModel = true
      this.$nextTick(() => {
        this.fillBlankTableHeight = this.$refs.fillBlankTableHeight.clientHeight
      })
    },
    saveInfeedFillBlank() {
      this.quesInfo.fvs.length = 0
      for (let item of this.infeedFillBlankTableData) {
        let temo = deepCopy(item)
        delete temo._index
        delete temo._rowKey
        this.quesInfo.fvs.push(temo)
      }
      if (
        this.quesInfo.fvs.filter((i) => i.isRequired === 1).length ===
        this.quesInfo.fvs.length
      ) {
        this.quesInfo.isRequired = 1
      }
      if (
        this.quesInfo.fvs.filter((i) => i.isRequired === 0).length ===
        this.quesInfo.fvs.length
      ) {
        this.quesInfo.isRequired = 0
      }
    },
    closeInfeedFillBlank() {},
    // 编辑表格
    editTableModel() {
      this.editTableData.length = 0
      for (let item of this.fillTableColoumns) {
        this.editTableData.push({
          fvName: item.title,
          fvType: item.fvType,
          isRequired: item.isRequired,
          orderNum: item.orderNum,
        })
      }
      this.showTableModel = true
      this.$nextTick(() => {
        this.tableHeight = this.$refs.tableB.clientHeight
      })
    },
    addTableData() {
      this.editTableData.push({
        fvName: '',
        fvType: 0,
        isRequired: 0,
        orderNum: this.editTableData.length + 1,
      })
    },
    saveTableModel() {
      this.quesInfo.fvs.length = 0
      this.fillTableColoumns.length = 0
      let count = 0
      for (let item of this.editTableData) {
        let temo = deepCopy(item)
        delete temo._index
        delete temo._rowKey
        this.quesInfo.fvs.push(temo)
        this.fillTableColoumns.push({
          title: temo.fvName,
          key: 'col' + count++,
          align: 'center',
          fvType: temo.fvType,
          orderNum: temo.orderNum,
          isRequired: temo.isRequired,
        })
      }
      if (
        this.quesInfo.fvs.filter((i) => i.isRequired === 1).length ===
        this.quesInfo.fvs.length
      ) {
        this.quesInfo.isRequired = 1
      }
      if (
        this.quesInfo.fvs.filter((i) => i.isRequired === 0).length ===
        this.quesInfo.fvs.length
      ) {
        this.quesInfo.isRequired = 0
      }
    },
    closeTableModel() {},
  },
}
</script>
<style lang="less" scoped>
.delIconStyle {
  font-size: 26px;
  margin-left: 15px;
  cursor: pointer;
}
.customControlMain {
  height: 100%;
  .singlePick {
    .options {
      padding: 10px;
      .optionItem {
        display: flex;
        align-items: center;
      }
    }
    // .addBtn {
    // }
  }
  .fillBlank {
    .blank {
      padding-top: 15px;
    }
    .blankSty {
      display: flex;
      .blankStyItem {
        width: 88%;
      }
    }
  }
  .divisionBox {
    height: 100%;
    display: flex;
    align-items: center;
    .division {
      width: 100%;
      height: 1px;
      border-bottom: 1px dotted #ccc;
    }
  }
  .fillTable {
    width: 100%;
    .tablebox {
      padding-top: 15px;
      display: flex;
      .table {
        width: 88%;
      }
    }
  }
}
// close input style
.noBorderByUnline {
  /deep/ .ivu-input {
    border: none;
    border-bottom: 1px solid #dddee1;
    border-radius: 0;
    outline: none;
    &:focus {
      border: none;
      box-shadow: none;
      border-bottom: 1px solid #dddee1;
    }
  }
}
.noBorder {
  /deep/ .ivu-input {
    border: none;
    border-radius: 0;
    outline: none;
    &:focus {
      border: none;
      box-shadow: none;
    }
  }
}
.infeedFillBlankDiv {
  height: 50vh;
  & > div {
    width: 100%;
  }
  .showArea {
    height: 40%;
  }
  .attrArea {
    height: 60%;
  }
}
.fillTableDiv {
  height: 50vh;
  .tableB {
    height: calc(~'100% - 40px');
  }
  .tableAddB {
    padding-top: 15px;
    height: 40px;
  }
}
</style>
<style lang="less">
.blackBg {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/pages/questionnaire/questionnaireList/CustomControl.vue